const Schedule = {
    local_user_time: "",
    timezone: "Europe/Berlin",
    platforms: ["linkedin"],
    publish_as: "",     // user id when planning on another group member's account, "" = own account
    post: { id: null }  // default post id, possibly null or 0
  };
  
 export default Schedule;
  